import cs from 'classnames';
import { HTMLAttributes, forwardRef } from 'react';
import {
  IChildrenProp,
  IJustifyPositionProps,
} from 'types/components/components.interface';
import './DropdownMenu.scss';

interface IDropdownMenuProps
  extends IJustifyPositionProps,
    IChildrenProp,
    HTMLAttributes<HTMLDivElement> {
  visible?: boolean;
  align?: 'top' | 'bottom';
}

const DropdownMenu = forwardRef<HTMLDivElement, IDropdownMenuProps>(
  (
    {
      children,
      justifyPosition = 'start',
      visible = false,
      align = 'bottom',
      ...props
    },
    ref
  ) => {
    const classNames = cs(['dropdown-menu', justifyPosition, align], {
      visible: visible,
      hiden: !visible,
    });

    return (
      <div ref={ref} className={classNames} {...props}>
        {children}
      </div>
    );
  }
);

export default DropdownMenu;
